import { Grid } from "@material-ui/core";
import { Logout } from "@mui/icons-material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../AppContext";
import ClosedOrders from "../../components/ClosedOrders/ClosedOrders";
import HelmetMeta from "../../components/HelmetMeta";
import LogoutButton from "../../components/LogoutButton";
import SimpleSpeedDialActions from "../../components/SimpleSpeedDialActions";
import TakeawayOrders from "../../components/TakeawayOrders/TakeawayOrders";
import TakeawayOrdersList from "../../components/TakeawayOrders/TakeawayOrdersList";
import cayLogo from "../../images/logo.png";
import { useSiteSettings } from "../../shared/hooks/useFrappeDoctype";
import { PosContext } from "../../shared/PosContext";
import { useStyles } from "../NewTables/styles";
import PosProfileDialog from "../Widgets/PosProfileDialog";
import ReservationDialog from "../Widgets/ReservationDialog";
import WidgetsDialogs from "../Widgets/WidgetsDialogs";
import CustomerBrowserDialog from "./CustomerBrowserDialog";
import PosCashCloseDialog from "../../components/PosCashCloseDialog/PosCashCloseDialog";
import { useSearchPOSOpening } from "../../shared/hooks/usePOSData";

const OrderTabs = () => {
    const { data: siteSettings, isFetched } = useSiteSettings();
    const { userInfo } = useContext(AppContext);
    const { setSelectedCustomer } = useContext(PosContext);
    const [closePOSDialgOpen, setClosePOSDialogOpen] = useState(false);
    const { refetch: refetchTodayOpen } = useSearchPOSOpening({ user: userInfo.name });

    const toggleClosePOSDialog = () =>
        setClosePOSDialogOpen(!closePOSDialgOpen);

    useEffect(() => {
        setSelectedCustomer(null);
    }, []);

    const logoUrl = useMemo(() => {
        if (siteSettings) {
            return siteSettings?.docs[0]?.logo || cayLogo;
        } else {
            if (isFetched) {
                return cayLogo;
            }
        }
    }, [siteSettings]);

    const {
        changeSelectedTable,
        posEntryDetails,
        refetchTablesData,
        selectedTable,
    } = useContext(PosContext);

    const { posProfile } = useContext(AppContext);

    const classes = useStyles();

    const selectedOrder = useMemo(() => {
        if (selectedTable) {
            return Object.values(selectedTable.orders)[0];
        } else {
            return null;
        }
    }, [selectedTable]);

    const [widgetsDialogsOpen, setWidgetsDialogsOpen] = useState(false);

    const [takeawayOrdersOpen, setTakeawayOrdersOpen] = useState(false);

    const [closedOrdersOpen, setClosedOrdersOpen] = useState(false);
    const toggleClosedOrders = () => setClosedOrdersOpen(!closedOrdersOpen);

    const [posProfileOpen, setPosProfileOpen] = useState(false);
    const togglePosProfile = () => setPosProfileOpen(!posProfileOpen);

    const [customerBrowserOpen, setCustomerBrowserOpen] = useState(false);
    const toggleCustomerBrowser = () => setCustomerBrowserOpen((v) => !v);

    useEffect(() => {
        if (!posProfile) {
            setPosProfileOpen(true);
        }
    }, [posProfile]);

    useEffect(() => {
        changeSelectedTable(null);
    }, []);

    useEffect(() => {
        refetchTablesData();
    }, []);

    const handleInvoiceClosed = () => {
        setWidgetsDialogsOpen(false);
    };

    const handleCloseDialog = () => {
        setWidgetsDialogsOpen(false);
    };

    const handleTakeawayOrders = () => {
        setTakeawayOrdersOpen(true);
        changeSelectedTable("takeaway");
    };

    const handleClosedOrders = () => {
        toggleClosedOrders();
    };

    const handleTakeawayOrdersClose = () => {
        setTakeawayOrdersOpen(false);
        changeSelectedTable(null);
    };

    const handleClosePOSCash = () => {
        toggleClosePOSDialog();
    };

    return (
        <React.Fragment>
            <HelmetMeta title={"Tables"} />
            <div className={classes.PageWrap}>
                <div className={classes.NewTablesPage}>
                    <div className={classes.Header} id="Pos_Header">
                        <div className="Logo">
                            <img src={logoUrl} />
                        </div>

                        <div className="SettingsIcon">
                            <LogoutButton icon={<Logout />} />
                        </div>
                    </div>
                    <div className={classes.Body}>
                        <div className={classes.Body__TableView}>
                            <Grid
                                container
                                spacing={2}
                                style={{
                                    padding: "1rem",
                                    flex: 1,
                                    height: "100%",
                                    overflow: "hidden",
                                }}
                            >
                                <Grid
                                    s
                                    item
                                    xs={12}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: 1,
                                        minHeight: 0,
                                    }}
                                >
                                    <div style={{ flex: 1, minHeight: 0 }}>
                                        <TakeawayOrdersList
                                            title="orders"
                                            onOpenCustomerBrowser={
                                                toggleCustomerBrowser
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <SimpleSpeedDialActions
                            handleTakeawayOrders={handleTakeawayOrders}
                            handleClosedOrders={handleClosedOrders}
                            handleClosePOSCash={handleClosePOSCash}
                        />
                    </div>
                </div>
            </div>
            <WidgetsDialogs
                open={widgetsDialogsOpen}
                onClose={handleCloseDialog}
                onInvoiceClose={handleInvoiceClosed}
                order={selectedOrder}
            ></WidgetsDialogs>

            <TakeawayOrders
                open={takeawayOrdersOpen}
                onClose={handleTakeawayOrdersClose}
            />

            <ClosedOrders
                open={closedOrdersOpen}
                onClose={toggleClosedOrders}
            />

            <PosProfileDialog
                open={posProfileOpen}
                onClose={togglePosProfile}
            />

            <ReservationDialog />

            <CustomerBrowserDialog
                open={customerBrowserOpen}
                onClose={toggleCustomerBrowser}
            />

            {closePOSDialgOpen && (
                <PosCashCloseDialog
                    open={closePOSDialgOpen}
                    onClose={toggleClosePOSDialog}
                    onSuccess={(res) => {
                        refetchTodayOpen();
                    }}
                />
            )}
        </React.Fragment>
    );
};

export default OrderTabs;
